import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    Cell,
    ResponsiveContainer,
} from "recharts";

import {
    Card,
    Row,
    Col,
    Typography,
    DatePicker,
    Select,
    Form,
    Table,
    Progress,
    Space
} from "antd";
// import ViewEmpCalendar from "./ViewEmpCalendar";
import { useState, useEffect, useContext } from "react";
import dayjs from "dayjs";
import { AuthContext } from "../context/AuthContext";
import axios from "axios";
import LeaveCalendar from "./employee/LeaveCalendar";

const { Title, Text } = Typography;
const { Option } = Select;

export default function ViewOneEmpPerm({ employee, isProfile }) {
    const currentMonth = dayjs().month() + 1;
    const currentYear = dayjs().year();
    const { authData, backUrl } = useContext(AuthContext);
    const [leaves_taken_breakdown, setLeavesTakenBreakdown] = useState({})

    useEffect(() => {
        setLeavesTakenBreakdown(employee.leaves_taken_breakdown)
    })

    const [graphData, setGraphData] = useState({
        month: currentMonth,
        year: currentYear,
    });
    const [totalLeaves, setTotalLeaves] = useState([]);

    // ✅ Fetch total leaves with Bearer token
    const fetchTotalLeaves = async () => {
        try {
            const res = await axios.get(
                `${backUrl}/api/hr/permissions/?employee=${employee.id || employee.employee.id}`,
                {
                    headers: {
                        Authorization: `Bearer ${authData?.access}`,
                    },
                }
            );
            setTotalLeaves(res.data.results || []);
        } catch (err) {
            console.error("Error fetching total leaves:", err);
        }
    };

    useEffect(() => {
        if (employee?.id) fetchTotalLeaves();
    }, [employee]);

    // ✅ Filter leave data based on selected month and year
    const filteredLeaves = totalLeaves.filter((leave) => {
        const start = dayjs(leave.start_date);
        const matchesMonth =
            !graphData.month || start.month() + 1 === graphData.month;
        const matchesYear = !graphData.year || start.year() === graphData.year;
        return matchesMonth && matchesYear;
    });
    console.log("Employee", employee)

    // ✅ Compute leave counts by total days
    const leaveTypeCounts = filteredLeaves.reduce((acc, leave) => {
        const type = leave.leave_type || "Unknown";
        const days = Number(leave.leave_days_count) || 0;
        acc[type] = (acc[type] || 0) + days;
        return acc;
    }, {});

    const pieData = Object.entries(leaveTypeCounts).map(([name, value]) => ({
        name,
        value,
    }));

    const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#A28EFF"];

    const handleMonthChange = (date) => {
        setGraphData((prev) => ({
            ...prev,
            month: date ? date.month() + 1 : "",
        }));
    };

    const handleYearChange = (value) => {
        setGraphData((prev) => ({ ...prev, year: value }));
    };

    const years = Array.from({ length: 10 }, (_, i) => currentYear - i);

    const leaveColumns = [
        { title: "Session", dataIndex: "session", key: "session" },
        {
            title: "Date",
            dataIndex: "date",
            key: "date",
            render: (date) => dayjs(date).format("DD/MM/YYYY"),
        },
        {
            title: "Time",
            dataIndex: "time",
            key: "time",
        },
        {
            title: "Reason",
            dataIndex: "reason",
            key: "reason",
            width: 300,
            render: (text) => (
                <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
                    {text}
                </div>
            ),
        },
        { title: "Hours Requested", dataIndex: "hours_requested", key: "hours_requested" },
        {
            title: "Status",
            dataIndex: "approve_status",
            key: "approve_status",
            render: (status) => (
                <span
                    style={{
                        color:
                            status === "Approved"
                                ? "green"
                                : status === "Rejected"
                                    ? "red"
                                    : "orange",
                        fontWeight: 500,
                    }}
                >
                    {status}
                </span>
            ),
        },
    ];

    // ✅ Summary (SL, CL, EL)
    const totalDaysByType = {
        SL: leaveTypeCounts["Sick Leave"] || 0,
        CL: leaveTypeCounts["Casual Leave"] || 0,
        EL: leaveTypeCounts["Earned Leave"] || 0,
    };

    return (
        <Card bordered={false} style={{ margin: "5px", width: "100%" }}>
            {/* ✅ Month / Year Filters */}
            <Form
                layout="inline"
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    gap: "10px",
                    marginBottom: "20px",
                }}
            >
                <Form.Item label="Month">
                    <DatePicker
                        picker="month"
                        onChange={handleMonthChange}
                        allowClear
                        value={graphData.month ? dayjs().month(graphData.month - 1) : null}
                        style={{ width: 160 }}
                    />
                </Form.Item>

                <Form.Item label="Year">
                    <Select
                        style={{ width: 140 }}
                        placeholder="Select Year"
                        onChange={handleYearChange}
                        allowClear
                        value={graphData.year}
                    >
                        {years.map((yr) => (
                            <Option key={yr} value={yr}>
                                {yr}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            </Form>

            {/* ✅ Leave Table */}
            <Table
                columns={leaveColumns}
                dataSource={filteredLeaves.map((item) => ({
                    ...item,
                    key: item.id,
                }))}
                pagination={{ pageSize: 5, responsive: true }}
                scroll={{ x: "max-content" }}
                components={{
                    header: {
                        cell: (props) => (
                            <th
                                {...props}
                                style={{
                                    backgroundColor: "#0e497b",
                                    color: "white",
                                    textAlign: "center",
                                }}
                            >
                                {props.children}
                            </th>
                        ),
                    },
                }}
            />

            {!isProfile && (
                <>

                </>
                // <Row gutter={[24, 24]} justify="center" style={{ marginTop: 30 }}>
                //     {/* Calendar Section */}
                //     <Col xs={24} md={14} lg={16}>
                //         <div
                //             style={{
                //                 width: "100%",
                //                 height: 450,
                //                 overflowY: "auto",
                //                 border: "1px solid #f0f0f0",
                //                 borderRadius: "8px",
                //                 padding: "10px",
                //             }}
                //         >
                //             <LeaveCalendar employee={employee} />
                //         </div>
                //     </Col>

                //     {/* Chart Section */}
                //     {/* <Col xs={24} md={10} lg={8}>
                //     <div style={{ height: 300 }}>
                //         <ResponsiveContainer width="100%" height="100%">
                //             <BarChart
                //                 data={pieData}
                //                 margin={{ top: 20, right: 30, left: 0, bottom: 10 }}
                //             >
                //                 <CartesianGrid strokeDasharray="3 3" />
                //                 <XAxis dataKey="name" />
                //                 <YAxis />
                //                 <Tooltip />
                //                 <Legend />
                //                 <Bar dataKey="value" fill="#0e497b">
                //                     {pieData.map((entry, index) => (
                //                         <Cell
                //                             key={`cell-${index}`}
                //                             fill={COLORS[index % COLORS.length]}
                //                         />
                //                     ))}
                //                 </Bar>
                //             </BarChart>
                //         </ResponsiveContainer>
                //     </div>
                // </Col> */}
                // </Row>
            )}

            {/* ✅ Calendar + Bar Chart Section */}

        </Card>
    );
}
